const getTelephoneNumber = (telephone) => telephone.trim().replace(/\D/g, '')

export default getTelephoneNumber